import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m4 20 1.149-4.265a7.88 7.88 0 0 1-.83-5.46A7.9 7.9 0 0 1 7.283 5.61a7.94 7.94 0 0 1 10.36.668 7.879 7.879 0 0 1 .805 10.316 7.93 7.93 0 0 1-4.643 3.013 7.95 7.95 0 0 1-5.489-.756zm4.523-2.745.267.157a6.42 6.42 0 0 0 7.757-.94 6.365 6.365 0 0 0 1.071-7.715 6.4 6.4 0 0 0-3.091-2.725 6.43 6.43 0 0 0-4.118-.28 6.4 6.4 0 0 0-3.434 2.282 6.37 6.37 0 0 0-1.324 3.897 6.3 6.3 0 0 0 .936 3.309l.168.274-.643 2.38z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.055 12.636a1.4 1.4 0 0 0-.559-.256 1.5 1.5 0 0 0-.62.002c-.307.12-.505.574-.704.801a.3.3 0 0 1-.172.107.3.3 0 0 1-.205-.027 5.27 5.27 0 0 1-2.67-2.158.29.29 0 0 1 .042-.419c.22-.206.383-.462.472-.743.02-.31-.056-.62-.217-.89a2.1 2.1 0 0 0-.684-.975 1 1 0 0 0-1.015.147 2 2 0 0 0-.548.702A1.9 1.9 0 0 0 8 9.783q.001.249.066.49c.11.384.278.751.5 1.09q.24.39.524.752a7.9 7.9 0 0 0 2.27 1.985c.444.263.919.476 1.415.636.515.22 1.084.305 1.647.245.32-.046.623-.165.883-.347.26-.183.469-.423.608-.699a.84.84 0 0 0 .07-.534c-.085-.37-.608-.587-.93-.765",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }